import React from 'react';
import NewLogo from '../images/newlogo.png';
const NKBPutReport = (props)=>{

  const reportData = props.reportData;
  console.log("repsdar",reportData);
  const imageData = props.imageData;
  const reportDate = props.reportDate;
  const reportType = props.reportType;
  const IntraDayChecked = props.IntraDayChecked;

      const formatdate = (dateString)=>{
  
        const dateObject = new Date(dateString);
        const day = dateObject.getDate();
        const month = dateObject.getMonth() + 1; // Months are zero-based
        const year = dateObject.getFullYear();
    
        // Pad single-digit day and month with a leading zero
        const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;
    
        return formattedDate;
    }

return(
  <div className="img-container">

<div className='preview-container'>
              <div className='preview-header'>
                <figure><img src={NewLogo} alt='Rakesh Kumar Bansal Ventures' /></figure>
                <h5>51,PKT-A1,Keshav Puram <br/>New Delhi- 110035</h5>
                <div className='right'>
                  <p><b>Research Report Dated:</b> {reportDate.toString()}</p>
                  <p><b>Segment:</b>  {IntraDayChecked === true? "Intra day/BTST":reportType.toString()}</p>
                </div>
              </div>
              <div className='table'>
                <table>
                  <tbody>
                    <tr>
                      <td><b>BUY</b></td>
                      <td>{reportData.stockType.toString()}</td>
                    </tr>
                   
                    <tr>
                      <td><b>CMP</b></td>
                      <td>{reportData.optionCMP.toString()}</td>
                    </tr>
                    <tr>
                      <td><b>SL</b></td>
                      <td>{reportData.optionSL.toString()}</td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
              <div className='remarks'>
              {reportData.optionRemark.toString() == ''?
    null  : <p><b>Remarks:</b><span style={{ color: reportData.optionSL.toString() == 0 ? 'red' : 'black',}} id="remarks">{reportData.optionRemark.toString()}</span></p>
  }
                <p>
       {reportData.commentry.toString()}
      </p>
              </div>
              <div className='chart-image'>
              <img  id="reportimage" src={imageData} alt="chart image" />
                
              </div>
              <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
              <h3 class="report-disclaimer">Disclaimer</h3>
              </div>
              <h5>“Investment in the securities market is subject to market risks. Read all the related documents carefully 
                before investing.”</h5>
              <p>
                We don’t guarantee any kind of profit. The stock market involves risk, and trade only if you are comfortable with risk. Please don’t trade/invest based on our performance sheet, as past performance is not a guarantee of future performance. Our performance sheet is for our own satisfaction & transparency.  You may or may not be able to buy/sell at our recommended price as recommendations are shared in live/running market and we cannot freeze stock price to help you buy/sell at recommended price. our humble request please trade/invest as per your individual risk appetite.
              </p>
              <h5>Risk disclosures on derivatives:</h5>
              <p>
                <strong>9</strong> out of <strong>10</strong> individual traders in the equity Futures and Options Segment incurred net losses. On average, loss-makers registered net trading losses close to <strong>₹50,000</strong>. Over and above the net trading losses incurred, loss-makers expended an additional <strong>28%</strong> of net trading losses as transaction costs. Those making net trading profits incurred between <strong>15%</strong> to <strong>50%</strong> of such profits as transaction costs. <br></br>
                Source: SEBI study dated <strong>25 January 2023</strong>, on “Analysis of Profit and Loss of Individual Traders dealing in equity Futures and Options (F&O) Segment”, wherein Aggregate Level findings are based on the annual <strong>Profit/Loss</strong> incurred by individual traders in equity F&O during <strong>FY 2021-22</strong>.
              </p>
              <p>Registration granted by SEBI and certification from
NISM in no way guarantee performance of the intermediary or provide
any assurance of returns to investors.</p>
              <h5>Please find the disclaimer link:
                <a className="disclaimer-link" href="https://www.iamrakeshbansal.com/disclaimer/" target="_blank">
                  https://www.iamrakeshbansal.com/disclaimer
                </a>
              </h5>


              <h5 style={{
                borderTop: '1px solid rgba(0,0,0,0.3)',
                borderBottom: '0',
                display: 'flex',
                fontSize: '12px',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                margin: '0',
                // marginTop: '200px',
                padding: '10px'
            }}>
                <span><a href="http://www.iamrakeshbansal.com/">www.iamrakeshbansal.com</a></span>
                <span>SEBI Registration: INH100008984</span>
                <span>Page 1</span>
            </h5>
             
            </div>

    
  </div>
);
};

export default NKBPutReport;
